import { createSelector } from 'reselect'

import {
  LOGIN_STATE_AUTH_POPUP,
  LOGIN_STATE_EMAIL_POPUP,
  LOGIN_STATE_EMAIL_SUCCESS_POPUP,
  LOGIN_STATE_PASSWORD_POPUP,
  LOGIN_STATE_UNLINK_POPUP,
  REQUEST_STATUS_COMPLETED,
  REQUEST_STATUS_SUCCESS
} from './constants'

const accountSettingsSelector = ({ account_settings: accountSettings }) => accountSettings

export const userSettingsSelector = createSelector(
  accountSettingsSelector,
  ({ userSettings }) => userSettings
)

const metaSelector = createSelector(
  accountSettingsSelector,
  ({ meta }) => meta
)

const deletionSelector = createSelector(
  metaSelector,
  ({ deletion }) => deletion
)

export const deletionRedirectToSelector = createSelector(
  deletionSelector,
  ({ redirect_to: redirectTo }) => redirectTo
)

const loginTabSliceSelector = createSelector(
  accountSettingsSelector,
  ({ loginTab }) => loginTab || {}
)

const loginPopupStateSelector = createSelector(
  loginTabSliceSelector,
  ({ popupState }) => popupState
)

export const unlinkPopupPageSelector = createSelector(
  loginTabSliceSelector,
  ({ unlinkPopupPage }) => unlinkPopupPage
)

export const unlinkVerificationCodeSelector = createSelector(
  loginTabSliceSelector,
  ({ unlinkVerificationCode }) => unlinkVerificationCode
)

export const isAuthPopupOpenSelector = createSelector(
  loginPopupStateSelector,
  (loginPopupState) => loginPopupState === LOGIN_STATE_AUTH_POPUP
)

export const isEmailUpdatePopupOpenSelector = createSelector(
  loginPopupStateSelector,
  (loginPopupState) => loginPopupState === LOGIN_STATE_EMAIL_POPUP
)

export const isEmailUpdateSuccessPopupOpenSelector = createSelector(
  loginPopupStateSelector,
  (loginPopupState) => loginPopupState === LOGIN_STATE_EMAIL_SUCCESS_POPUP
)

export const isPasswordUpdatePopupOpenSelector = createSelector(
  loginPopupStateSelector,
  (loginPopupState) => loginPopupState === LOGIN_STATE_PASSWORD_POPUP
)

export const isUnlinkPopupOpenSelector = createSelector(
  loginPopupStateSelector,
  (loginPopupState) => loginPopupState === LOGIN_STATE_UNLINK_POPUP
)

export const desiredAuthSelector = createSelector(
  loginTabSliceSelector,
  ({ desiredAuth }) => desiredAuth
)

export const changedEmailSelector = createSelector(
  loginTabSliceSelector,
  ({ changedEmail }) => changedEmail
)

export const isDataLoadingSelector = createSelector(
  accountSettingsSelector,
  ({ isDataLoading }) => isDataLoading
)

const brandingSettingsSelector = createSelector(
  accountSettingsSelector,
  ({ branding }) => branding
)

export const canEnforceLogoSelector = createSelector(
  brandingSettingsSelector,
  ({ canEnforceLogo }) => canEnforceLogo
)

export const canUpdateLogoSelector = createSelector(
  brandingSettingsSelector,
  ({ canUpdateLogo }) => canUpdateLogo
)

export const isBrandedSelector = createSelector(
  brandingSettingsSelector,
  ({ unbranded }) => !unbranded
)

export const hideCalendlyBrandingSelector = createSelector(
  brandingSettingsSelector,
  ({ hideCalendlyBranding }) => hideCalendlyBranding
)

export const isProfileLogoSelector = createSelector(
  brandingSettingsSelector,
  ({ isProfileLogo }) => isProfileLogo
)

export const brandingLogoUrlSelector = createSelector(
  brandingSettingsSelector,
  ({ logoUrl }) => logoUrl
)

export const useOwnerCalendlyBrandingSelector = createSelector(
  brandingSettingsSelector,
  ({ useOwnerCalendlyBranding }) => useOwnerCalendlyBranding
)

export const lastChangeCopySelector = createSelector(
  brandingSettingsSelector,
  ({ lastChangeCopy }) => lastChangeCopy
)

export const brandingSaveRequestCompletedRequestSelector = createSelector(
  brandingSettingsSelector,
  ({ requestStatus }) => requestStatus === REQUEST_STATUS_COMPLETED
)

export const smsLegalDisclaimerSelector = createSelector(
  brandingSettingsSelector,
  ({ smsLegalDisclaimer }) => smsLegalDisclaimer
)

export const changeOwnerMembersSelector = createSelector(accountSettingsSelector,
  ({ changeOwnerPopup }) => changeOwnerPopup.members
)

export const changeOwnerLoadingSelector = createSelector(
  accountSettingsSelector,
  ({ changeOwnerPopup }) => changeOwnerPopup.isLoading
)

export const changeOwnerSaveLoadingSelector = createSelector(
  accountSettingsSelector,
  ({ changeOwnerPopup }) => changeOwnerPopup.isLoadingOwnerChange
)
export const changeOwnerIsCompletedSelector = createSelector(
  accountSettingsSelector,
  ({ changeOwnerPopup }) => changeOwnerPopup.isCompleted
)

export const profileSaveRequestCompletedSelector = createSelector(
  accountSettingsSelector,
  ({ saveProfileRequestStatus }) => saveProfileRequestStatus === REQUEST_STATUS_SUCCESS
)
